module.exports = __webpack_public_path__ + "static/media/farmaciaSchiratti.5c951cad.jpeg";